import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ToastType } from "src/app/constants/toast-type";
import { ToastService } from "src/app/services/toast.service";

@Component({
    selector: 'mwp-agent-sass-toast',
    templateUrl: './sass-toast.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SassToastComponent {
    constructor(
        private toastService: ToastService,
    ){
    }

    public errorToast(): void {
        this.toastService.buildToastMessage(ToastType.error, 'Error', 'This is a test for Review SASS!');
    }

    public warningToast(): void {
        this.toastService.buildToastMessage(ToastType.warning, 'Warning', 'This is a test for Review SASS!');
    }

    public infoToast(): void {
        this.toastService.buildToastMessage(ToastType.info, 'Information', 'This is a test for Review SASS!');
    }

    public successToast(): void {
        this.toastService.buildToastMessage(ToastType.success, 'Success', 'This is a test for Review SASS!');
    }
}